import React from 'react';
function SuccessBadge() {
    return ( 
        <div className='w-10/12 h-6  text-green-600'>
            <p>Correct!!</p>
        </div>
     );
}

export default SuccessBadge;